import React from 'react';

const StudentsListSkeletonLoader: React.FC = () => {
  return (
    <>
      {/* Table Container Skeleton */}
      <div style={{
        background: 'white',
        borderRadius: '20px',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
        width: '100%'
      }}>
        {/* Info Bar Skeleton */}
        <div style={{
          padding: '16px 20px',
          borderBottom: '1px solid #f3f4f6',
          background: '#fafbfc',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{
              width: '32px',
              height: '32px',
              borderRadius: '8px',
              background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 2s infinite'
            }}></div>
            <div style={{
              width: '200px',
              height: '16px',
              borderRadius: '8px',
              background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
              backgroundSize: '200% 100%',
              animation: 'shimmer 2s infinite'
            }}></div>
          </div>
          <div style={{
            width: '80px',
            height: '32px',
            borderRadius: '8px',
            background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
            backgroundSize: '200% 100%',
            animation: 'shimmer 2s infinite'
          }}></div>
        </div>

        {/* Table Rows Skeleton */}
        <div style={{ padding: '20px' }}>
          {[...Array(10)].map((_, index) => (
            <div
              key={index}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                padding: '16px',
                borderBottom: index < 9 ? '1px solid #f3f4f6' : 'none',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${index * 0.1}s`
              }}
            >
              {/* Serial Number */}
              <div style={{
                width: '28px',
                height: '28px',
                borderRadius: '6px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                flexShrink: 0
              }}></div>

              {/* Student Name */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: '1', minWidth: 0 }}>
                <div style={{
                  width: '38px',
                  height: '38px',
                  borderRadius: '10px',
                  background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                  backgroundSize: '200% 100%',
                  animation: 'shimmer 2s infinite',
                  flexShrink: 0
                }}></div>
                <div style={{ minWidth: 0 }}>
                  <div style={{
                    width: '80%',
                    height: '16px',
                    borderRadius: '8px',
                    background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                    backgroundSize: '200% 100%',
                    animation: 'shimmer 2s infinite',
                    marginBottom: '8px'
                  }}></div>
                  <div style={{
                    width: '60%',
                    height: '14px',
                    borderRadius: '8px',
                    background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                    backgroundSize: '200% 100%',
                    animation: 'shimmer 2s infinite'
                  }}></div>
                </div>
              </div>

              {/* Father Name */}
              <div style={{
                width: '120px',
                height: '16px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                flexShrink: 0
              }}></div>

              {/* Contact */}
              <div style={{
                width: '100px',
                height: '16px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                flexShrink: 0
              }}></div>

              {/* Roll No */}
              <div style={{
                width: '40px',
                height: '24px',
                borderRadius: '6px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                flexShrink: 0
              }}></div>

              {/* Admission No */}
              <div style={{
                width: '100px',
                height: '16px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                flexShrink: 0
              }}></div>

              {/* Class */}
              <div style={{
                width: '80px',
                height: '16px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                flexShrink: 0
              }}></div>

              {/* Section */}
              <div style={{
                width: '60px',
                height: '16px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                flexShrink: 0
              }}></div>

              {/* DOB */}
              <div style={{
                width: '80px',
                height: '16px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite',
                flexShrink: 0
              }}></div>

              {/* Actions */}
              <div style={{ display: 'flex', gap: '4px', justifyContent: 'center', flexShrink: 0 }}>
                {[...Array(4)].map((_, i) => (
                  <div
                    key={i}
                    style={{
                      width: '32px',
                      height: '32px',
                      borderRadius: '50%',
                      background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                      backgroundSize: '200% 100%',
                      animation: 'shimmer 2s infinite'
                    }}
                  ></div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Pagination Skeleton */}
        <div style={{
          background: '#fafbfc',
          borderTop: '1px solid #e5e7eb',
          padding: '20px 16px',
          display: 'flex',
          justifyContent: 'center',
          gap: '8px'
        }}>
          {[...Array(7)].map((_, i) => (
            <div
              key={i}
              style={{
                width: '36px',
                height: '36px',
                borderRadius: '8px',
                background: 'linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 2s infinite'
              }}
            ></div>
          ))}
        </div>
      </div>

      {/* Animation styles */}
      <style>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </>
  );
};

export default StudentsListSkeletonLoader;
